/**
 * True when this browser lacks a JavaScript feature the app or a library it loads calls, so the app shows
 * OldBrowserWarning up front instead of failing part-way through a page. `Promise.withResolvers` is the one pdf.js 5
 * (react-pdf) calls to open every PDF; Chrome 119, Firefox 121 and Safari 17.4 were the first to ship it.
 */
export function isUnsupportedBrowser(): boolean {
  return (
    typeof Array.prototype.at !== "function" ||
    typeof Array.prototype.toSorted !== "function" ||
    typeof Promise.withResolvers !== "function"
  );
}
